import { render, staticRenderFns } from "./LocusZoom.vue?vue&type=template&id=2ff94b80&"
import script from "./LocusZoom.vue?vue&type=script&lang=js&"
export * from "./LocusZoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff94b80')) {
      api.createRecord('2ff94b80', component.options)
    } else {
      api.reload('2ff94b80', component.options)
    }
    module.hot.accept("./LocusZoom.vue?vue&type=template&id=2ff94b80&", function () {
      api.rerender('2ff94b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lz/LocusZoom.vue"
export default component.exports